const catchErrorAndCloseLoading = (closeLoading: () => void) => () => {
   closeLoading();
};

export default catchErrorAndCloseLoading;
